export default "__VITE_ASSET__DzGPMSZ8__"